import { mapState } from 'vuex'
import { contentApi } from '@/boot-api/cms'
export default {
   
    data() {
        return {
            list: [],
            filters: {
                catalogId: null,
                pageNum: 1,
                contentType: 0,
                keyword: null,
                pageSize:  10,
                status: 1,
                mySubmit: false
            },
            loading: false,
            total: 0,
            totalPage: 0
        }
    },
    computed: {
        ...mapState('user', {
            currentUser: (state) => state.info
        })
    },
    methods: {
        init(catalogId){
            // this.filters.pageSize = pageSize || this.filters.pageSize
            this.filters.catalogId = catalogId 
            this.list=[]
            this.getContentList(1)
        },
        setISubmit(v){
            this.filters.mySubmit=v
            this.list=[]
            this.getContentList(1)
        },
        getContentList(pageNum) {
            console.log('====minxin==')
            this.filters.pageNum = pageNum != null ? pageNum : this.filters.pageNum;
            this.loading = true
            this.list = []
            this.filters.status = this.filters.mySubmit ? null : 1
            contentApi.paging(this.filters).then(res => {
                this.total = res.data.total
                this.list = res.data.records
                this.totalPage = res.data.totalPage
                this.loading = false
            }).catch(e => console.log('====>', e))
        },
        onItemClick(item) {
            if (this.iSubmit) {
                this.$router.push(`/cms/content/editor?id=${item.id}`)
            } else {
            }

        },

        toArticle(item) {
            this.$router.push({ path: `/party-build/article?id=${item.id}&type=${item.type.code}&contentType=${item.contentType.code}` })
        },

        remove(item) {
            this.$confirm(`确定要删除文件? ${item.title}`).then(async _ => {
                await contentApi.remove([item.id])
                this.$message.success('删除成功')
                this.getContentList()
            }).catch(_ => { })
        },
        revoke(item) {
            this.$confirm(`确定撤回文件? ${item.title}`).then(async _ => {
                await contentApi.revoke({ id: item.id })
                this.$message.success('撤回成功')
                this.getContentList()
            }).catch(_ => { })
        },
        release(item) {
            if (!item.title) {
                this.$message.warning('尚未设置标题无法发布')
                return
            }
            this.$confirm(`确定要发布 ${item.title}`).then(async _ => {
                await contentApi.release({ id: item.id })
                this.$message.success(this.approve ? '已经发送审核,请等待审核结果' : '发布成功')
                this.getContentList()
            }).catch(_ => { })
        },
        // 跳转编辑器
        toEditor(item) {
            let url = item && item.extraJson && item.extraJson.showType == 1 ? "/cms/content/profile/editor" : "/cms/content/editor"
            if (item) {
                url = url + `?id=${item.id}`
            } else {
                url = url + `?catalogId=${this.currentCatalog.id}&from=0`
            }
            this.$router.push(`${url}&approve=${this.approve}`)
        }
    },
    mounted() {


    },
}


// WEBPACK FOOTER //
// ./src/views/party-build/article-list-mixin.js